import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ExpirationSettlementNewEditForm from './ExpirationSettlementNewEditForm';
// ----------------------------------------------------------------------

export default function ExpirationSettlementCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('ContractInfo.AddTitle')}`
          : `${translate('ContractInfo.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`${translate('ExpirationSettlement.Title')}`}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('contractsInfo.ContractInfoList')}`,
              href: PATH_DASHBOARD.ContractInfo.list,
            },
            {
              name: `${translate('ExpirationSettlement.Title')}`,
            },
          ]}
        />
        <ExpirationSettlementNewEditForm />
      </Container>
    </Page>
  );
}
